import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateSurveyMutationVariables = Types.Exact<{
  input: Types.CreateSurveyInput;
}>;


export type CreateSurveyMutation = { createSurvey: { survey?: { id: string } | null } };


export const CreateSurveyDocument = /*#__PURE__*/ gql`
    mutation createSurvey($input: CreateSurveyInput!) {
  createSurvey(data: $input) {
    survey {
      id
    }
  }
}
    `;

export function useCreateSurveyMutation() {
  return Urql.useMutation<CreateSurveyMutation, CreateSurveyMutationVariables>(CreateSurveyDocument);
};